<template>
  <div class="forgetPwd" :class="{ 'login-bg': success }">
    <div class="fixed-top only-pc button" style="background-color: rgba(255, 255, 255, 0.9)" @click="goToOfficial()">
      <img src="@/assets/images/logo/logo-black.png">
    </div>
    <div v-if="!success" class="my-header">重置密码</div>
    <div v-if="!success" class="new-wrapper">
      <form
        class="new-form"
        autocomplete="off"
        @submit.prevent="handleOnSubmit"
      >
        <div class="input-box">
          <div class="item">
            <span>新密码</span>
            <input
              v-model="password"
              class="input-item"
              :type="showPwd ? 'text' : 'password'"
              minlength="8"
              maxlength="16"
              placeholder="请输入密码"
              @input="handleValueChange('password')"
            >
          </div>
          <img
            v-if="showPwd"
            class="icon"
            src="@/assets/images/login/open-code.png"
            alt=""
            @click="togglePwd()"
          >
          <img
            v-else
            class="icon"
            src="@/assets/images/login/close-code.png"
            alt=""
            @click="togglePwd()"
          >
        </div>
        <div class="input-box">
          <div class="item">
            <span>确认新密码</span>
            <input
              v-model="confirmedPassword"
              class="input-item"
              :type="showPwd ? 'text' : 'password'"
              minlength="8"
              maxlength="16"
              placeholder="请输入密码"
              @input="handleValueChange('confirmPassword')"
            >
          </div>
          <img
            v-if="showPwd"
            class="icon"
            src="@/assets/images/login/open-code.png"
            alt="toggle-hide-password"
            @click="togglePwd()"
          >
          <img
            v-else
            class="icon"
            src="@/assets/images/login/close-code.png"
            alt="toggle-show-password"
            @click="togglePwd()"
          >
        </div>
        <div class="forgetPwd-tips">
          新密码必须满足以下要求：
          <ul>
            <li>1. 密码长度需要8至16位字符。</li>
            <li>2. 密码必须包含四种字符类型：小写字母、大写字母、数字和特殊字符（只限-_.~四种字符）。</li>
          </ul>
        </div>
        <div class="btnItem">
          <p class="errMessage">{{ this.errMsg }}</p>
          <p class="chat">
            如有问题，请通过
            <a @click="changeAccountNo">账号找回?</a>
            或
            <a @click="openLive800">联系客服</a>
          </p>
          <button
            type="submit"
            class="submit"
            style="margin-top: 0.2rem; border: none"
          >
            确认重置密码
          </button>
        </div>
      </form>
       <p class="reminder">温馨提示：若真实账号与模拟账号有绑定关系，将统一修改真实与模拟账号的密码；修改密码同时适用于账号下所有交易平台。</p>
    </div>
    <div v-else class="new-wrapper center-me">
      <div class="content">
        <div class="image-wrapper">
          <img
            src="@/assets/images/success/checked.png"
            alt="success image"
            class="big-image"
          >
        </div>
        <p class="title">重置密码成功</p>
        <p class="description">
          你的密码已重置成功，可以使用新密码登入。如有问题请<em
            class="primary"
            @click="openLive800()"
          >联系客服</em>。
        </p>
        <div class="button-group">
          <button class="secondary" @click="goToOfficial()">浏览官网</button>
          <button class="primary" @click="goToLogin()">立即登入</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
require('@/assets/css/forgetPwd.css')
require('@/assets/css/setPasswordByEmail.css')
import api from '@/plugins/api'
import { getDevice } from '@/utils/helper'
export default {
  name: 'SetPasswordByEmail',
  components: {},
  data() {
    return {
      title: '重置密码',
      rightContent: 'isNo',
      errMsg: '',
      customerNumber: '',
      key: this.$route.query.key,
      showPwd: false,
      password: '',
      confirmedPassword: '',
      success: false
    }
  },
  computed: {},
  methods: {
    openLive800() {
      var url =
      `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = screen.width / 2 - 600 / 2
      var top = screen.height / 2 - 400 / 2
      window.open(
        url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' +
          top +
          ', left=' +
          left
      )
    },
    togglePwd() {
      this.showPwd = !this.showPwd
    },
    handleValueChange(k) {
      if (!['password', 'confirmedPassword'].includes(k)) return
      this[k] = this[k].trim()
    },
    changeAccountNo() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/forgetPwdAcc' })
    },
    handleOnSubmit() {
      const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/
      if (!reg.test(this.password) || !reg.test(this.confirmedPassword)) {
        this.errMsg = '请输入8至16位字符，包括大小写字母、数字和特殊字符'
        return
      }
      if (this.password.trim() !== this.confirmedPassword.trim()) {
        this.errMsg = '两次密码输入不一'
        return
      }
      this.errMsg = ''
      const params = this.$qs.stringify({
        key: this.key,
        password: this.password
      })
      this.$bus.$emit('loading', false)
      try {
        api.setPasswordByEmail(params).then((res) => {
          this.$bus.$emit('loading', true)
          const data = res.data
          const { code, code_desc } = data
          if (code === 200) {
            // do something when success
            this.success = true
          } else {
            this.errMsg = code_desc
          }
        })
      } catch (err) {
        this.$bus.$emit('loading', true)
        this.errMsg = '发生网路错误，请稍候再试'
      }
    },
    goToLogin() {
      // const { isMobile } = getDevice()
      // if (isMobile) this.$router.push({ path: '/login' })
      // else window.location.href = process.env.VUE_APP_PC
      this.$router.push({ path: '/login' })
    },
    goToOfficial() {
      // const { isMobile } = getDevice()
      // if (isMobile) { window.open(process.env.VUE_APP_OFFICIAL_PAGE_M, 'M_OFFICIAL') } else window.open(process.env.VUE_APP_OFFICIAL_PAGE_PC, 'PC_OFFICIAL')
      window.open(process.env.VUE_APP_OFFICIAL_PAGE_PC, 'PC_OFFICIAL')
    }
  }
}
</script>
